import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import { addFlyerDate, addNewspaperDate, printDataUpdateRequest, printToolSetCustomDateSettings } from '../../../actions'
import { NEWSPAPER_DATA, PRINT_GENERAL_SETTINGS  } from '../../../constants/state'
import { FLYER, NEWSPAPER } from '../../../constants/printType'
import ChooseStartEndDate from '../present/ChooseStartEndDate'

const mapStateToProps = state => ({
    newspaperData: getData(state, NEWSPAPER_DATA),
    printGeneralSettingsData: getData(state, PRINT_GENERAL_SETTINGS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    printToolAddDatePeriod: (dateObj, pk) => {
        if (FLYER === ownProps.printType) {
            dispatch(addFlyerDate(dateObj, pk))
        } else if (NEWSPAPER === ownProps.printType) {
            dispatch(addNewspaperDate(dateObj))
        } else {
            dispatch(printToolSetCustomDateSettings(dateObj))
            dispatch(printDataUpdateRequest())
        }

        if(ownProps.path) {
            dispatch(push(ownProps.path))
        }
    }
})

const ChooseStartEndDateContainer = ({
    printPk,
    printType,

    printGeneralSettingsData,
    flyerServerData,
    newspaperData,
    printToolAddDatePeriod
}) => {
    const dateSettingsValues = {
        startDate:'',
        endDate:''
    }

    let data

    if(printType === FLYER) {
        data = (flyerServerData.flyers && flyerServerData.flyers[printPk]) ? flyerServerData.flyers[printPk] : null
    } else if(printType === NEWSPAPER) {
        data = newspaperData ? newspaperData : null
    } else {
        data = printGeneralSettingsData ? printGeneralSettingsData : null
    }

    const initValues = data && data.dateSettings ? data.dateSettings : dateSettingsValues

    if(!data) {
        return ''
    }

    return <ChooseStartEndDate
        printType={printType}

        data={data}
        initValues={initValues}

        printToolAddDatePeriod={printToolAddDatePeriod}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ChooseStartEndDateContainer)